<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>
                        <b>{{ $t('Upgles.form.Heading') }}</b>
                    </h5>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <Dropdown v-model="details.updation_time" :options="Timesdropdown" placeholder="선택" name="name" id="first_category" />
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Upgles.form.Heading2') }}</b>
                    </h5>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                            <label for="title2"
                                ><b>{{ $t('Upgles.form.FirstInfo') }}</b></label
                            >
                            <Textarea :class="`${error.description ? 'p-invalid' : ''}`" type="text" :placeholder="$t('Upgles.form.Desc')" id="desc1" v-model="details.description"></Textarea>
                            <div class="text-red">{{ error.description }}</div>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Upgles.form.Heading3') }}</b>
                    </h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-7 p-mb-lg-0 p-field">
                            <label for="subtitle2">
                                {{ $t('Upgles.form.Pic') }}
                                <!-- <span class="img-info">(File Type jpg,jpeg,png )</span> -->
                            </label>
                            <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                                <span v-if="!fileName">{{ $t('Upgles.form.Selectfile') }}</span>
                                <span v-else>{{ fileName }}</span>
                                <input type="file" class="select-file" v-on:change="onFileChange" />
                                <Button :label="$t('Upgles.form.select_file')" class="SelectBtn n-wrap" />
                            </div>
                            <label for="subtitle2">{{ $t('Upgles.list.File') }}</label
                            ><br />
                            <!-- <div class="text-red">{{ error.file }}</div> -->
                            <div class="text-red" v-show="render1">{{ $t('validation.invalidFile') }}</div>
                            <div class="text-red" v-show="render2">파일이 너무 큽니다</div>
                            <Image :src="modal_image" alt="이미지를 사용할 수 없음" class="product-image" width="137" height="85" preview />
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field" id="desc1">
                            <label for="title2"
                                ><b> {{ $t('Upgles.form.ModalInfo') }}</b></label
                            >
                            <Textarea :class="`${error.modal_info ? 'p-invalid' : ''}`" type="text" :placeholder="$t('Upgles.form.Desc')" id="desc1" v-model="details.modal_info"></Textarea>
                            <div class="text-red">{{ error.modal_info }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :label="$t('Upgles.form.Save')" icon="pi pi-check" iconPos="left" class="p-button p-button p-mr-2 p-mb-2" @click="confirm($event)" style="margin-top: -20px; background: black; color: white"></Button>
            </div>
        </form>
    </div>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card">
                <h5>
                    <b>{{ $t('Upgles.list.Heading') }}</b>
                </h5>
                <DataTable :value="results" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('No')" style="min-width: 4rem">
                        <template #body="{ index }">
                            <span class="p-column-title">#</span>
                            {{ index + 1 }}
                        </template>
                    </Column>
                    <Column field="Type" :header="$t('Upgles.list.Type')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Type</span>
                            {{ data.sub_type }}
                        </template>
                    </Column>
                    <Column :header="$t('Upgles.list.Days')" style="min-width: 12rem" field="validity_date" sortable="true">
                        <template #body="{ data }">
                            <span class="p-column-title">Days</span>
                            {{ `${data.validity_date}` }} {{ $t('Days') }}
                        </template>
                    </Column>
                    <Column :header="$t('Upgles.list.DiscountRate')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Discount rate</span>
                            {{ data.discount }}%
                        </template>
                    </Column>
                    <Column :header="$t('Upgles.list.OriginalPrice')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Original price</span>
                            <!-- <InputSwitch v-model="data.status" trueValue="active" @change="switchValue(data.id, data.status)" /> -->
                            {{ data.original_price }} {{ $t('Choco') }}
                        </template>
                    </Column>
                    <Column :header="$t('Upgles.list.Offeredprice')" style="min-width: 12rem" field="discounted_price" sortable="true">
                        <template #body="{ data }">
                            <span class="p-column-title">Offered price</span>
                            <!-- <InputSwitch v-model="data.status" trueValue="active" @change="switchValue(data.id, data.status)" /> -->
                            {{ data.discounted_price }} {{ $t('Choco') }}
                        </template>
                    </Column>
                    <Column :header="$t('Upgles.list.Active')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Active/Inactive</span>
                            <InputSwitch v-model="data.status" trueValue="active" @change="switchValue(data.id, data.status)" />
                            <!-- {{ data.status }} -->
                        </template>
                    </Column>

                    <Column :header="$t('Upgles.list.Action')" style="min-width: 6rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Balance</span>
                            <!-- <p style="display: none">{{ data.mobile }}</p> -->
                            <div style="display: flex">
                                <!-- <router-link :to="'/ViewRecruiter/'"
                                    ><Button label="info" class="p-button2"><i class="pi pi-eye p-mr-2"></i> </Button>
                                </router-link> -->
                                <router-link :to="'/PaidFeatureManagement/Upgle/EditUpgle/' + data.id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-user-edit p-mr-2"></i> </Button>
                                </router-link>
                                <!-- <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" /> -->
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import UpgleService from '../../../service/API/UpgleService';
import axios from 'axios';
export default {
    data() {
        return {
            loading1: false,
            products: null,
            expandedRows: [],
            results: [],
            render2: false,

            dropdownItem: null,
            error: {},
            //params for list
            name: '',
            status: '',
            email: '',
            phone_number: '',
            user: {
                menus: [],
            },
            fileName: '',
            fileExtension: '',
            filesExtension: '',
            files: '',
            filesName: '',
            file: '',
            modal_image: '',
            image: '',
            render1: false,
            ad_type_id: '6',
            details: { ad_type: '', created_at: '', description: '', modal_info: '', status: 'active', updation_time: '' },
            Timesdropdowns: '',
            Timesdropdown: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
            formData: new FormData(),
        };
    },
    // customerService: null,
    AdminService: null,
    created() {
        this.upgleService = new UpgleService();
    },
    mounted() {
        this.getUpgleList();
        this.getUpgleDetails();
    },
    watch: {},
    methods: {
        getUpgleDetails() {
            this.upgleService.UpgleDetail('upgle').then((res) => {
                this.details.status = res[0].status;
                this.details.ad_type = res[0].ad_type;
                this.details.description = res[0].description;
                this.modal_image = res[0].modal_image;
                this.details.modal_info = res[0].modal_info;
                this.details.updation_time = res[0].updation_time;
                console.log(res);
            });
        },
        getUpgleList() {
            this.loading1 = true;
            this.upgleService
                .getUpgleList('6')
                .then((res) => {
                    this.results = res.data.result;
                    // this.totalrecords = res.data.total_records;
                    // this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    console.log(res);
                })
                .catch((err) => console.log(err));
        },
        resetNotice() {
            this.notice_title = '';
            this.start_date = '';
            this.end_date = '';
            this.writer_name = '';
            this.sortByValue = 'id';
            this.sortOrderValue = 'desc';
            this.newnoticelist(); // for refresh the table data
        },
        switchValue(ids, switchstatus) {
            console.log(ids, switchstatus);
            var self = this;
            axios({ method: 'post', url: 'api/v1/admin/ad-type/status-update', data: { sub_type_id: ids, status: switchstatus === false ? 'inactive' : 'active' } }).then(function (response) {
                // this.$router.push({ name: 'Banner Management' });
                self.$toast.add({ severity: 'info', summary: '확인.', detail: '패키지 정보가 변경되었습니다.', life: 3000 });
                console.log(response);
            });
        },
        onFileChange(e) {
            // this.formData.delete('file');
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.file = files[0];
            var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!allowedExtensions.exec(this.file.name)) {
                this.render1 = true;
                return false;
            } else {
                this.render1 = false;
                if (this.file.size > 26214400) {
                    // alert('파일이 너무 큽니다  ');
                    this.render2 = true;
                } else {
                    this.render2 = false;
                    this.fileName = this.file.name;
                    this.formData.append('image', files[0]);
                }
            }
            this.fileExtension = this.fileName.replace(/^.*\./, '');
            console.log(this.fileName);
        },
        confirm(event) {
            // confirm($event)

            // alert(this.mydata.notice_id)
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '계속 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    // let vcheckData = {
                    //     // title: this.title,
                    //     // status: this.status ? 'active' : 'inactive',
                    //     file: this.image == '' ? '' : 'something',
                    // };
                    // const { isInvalid, error } = validateCreateEmergency(vcheckData);
                    // if (isInvalid) {
                    //     this.error = error;
                    //     console.log(error);
                    // } else {
                    this.formData.append('ad_type_id', this.ad_type_id);
                    this.formData.append('description', this.details.description);
                    this.formData.append('modal_info', this.details.modal_info);
                    this.formData.append('status', this.details.status);
                    this.formData.append('updation_time', this.details.updation_time);
                    // this.formData.append('status', this.statusdropdown?.name === undefined ? this.type : this.dropdownValueType?.name);
                    console.log(this.formData);
                    return axios.post('/api/v1/admin/ad-type/info/edit', this.formData).then((res) => {
                        // this.emergencyService.UpdateEmergency({ad_type_id:this.ad_type_id,description:this.details.description,modal_info:this.details.modal_info,status:this.details.status}).then((res) => {
                        console.warn(res);
                        console.log(this.formData);
                        this.getUpgleDetails();
                        this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '업글 상품 정보가 저장되었습니다.', life: 3000 });
                        // this.$router.push({ name: 'Upgle' });
                        // setTimeout(() => {
                        //     window.location.reload();
                        //     this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '업글 상품 정보가 저장되었습니다.', life: 3000 });
                        // }, 500);
                    });
                    // }
                },

                // reject: () => {
                //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                // },
            });
        },

        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}

.product-image {
    padding-top: 5px;
    border: 0px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px !important;
    height: 100px;
    float: left;
}

.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}

.SelectBtn {
    max-width: 100px;
}

.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

textarea#desc1 {
    height: 18vh;
}
</style>
